import React, { useState, useRef, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'

import { BsArrowLeftCircle } from 'react-icons/bs'
import { MdStore } from 'react-icons/md'
import { MdDashboard, MdCleaningServices } from 'react-icons/md'

import { SiOpenaccess } from 'react-icons/si'
import { MdLocalLaundryService } from 'react-icons/md'
//import Logo from '../assets/images/logo2.png'
import {
    sessionHandler,
    pageMenuHandler,
    authTokenHandler,
    roleHandler
} from "../util/local-storage";

import logoMap from '../assets/images/v1/icon-menu-location.png'
import Logo from '../assets/images/v1/logo-lu-circle.png'
import iconAdd from '../assets/images/v1/icon-add-round.png'
import POS from '../assets/images/Icon_POS.png'
import Delivery from '../assets/images/Icon_Delivery.png'
import Analytics from '../assets/images/Icon_Analytics.png'
import Branch from '../assets/images/Icon_Branch.png'
import Cash from '../assets/images/Icon_Cash.png'
import Operation from '../assets/images/Icon_Operation.png'
import Stock from '../assets/images/Icon_stock.png'
import Customer from '../assets/images/Icon_Customer.png'
import { TbTruckDelivery, TbListDetails } from 'react-icons/tb'
import { MdStoreMallDirectory, MdOutlineDataExploration, MdOutlinePayments, MdOutlineFilterList, MdIron } from 'react-icons/md'
import { FaTasks, FaUserCog, FaCoins, FaWallet, FaMapMarkerAlt, FaRegCalendarAlt } from 'react-icons/fa'
import { BsCashCoin, BsShopWindow } from 'react-icons/bs'
import { GrVend, GrMap, GrHostMaintenance, GrVmMaintenance } from 'react-icons/gr'
import { RiCustomerService2Fill } from 'react-icons/ri'
import { AiOutlineLogin, AiTwotoneShop, AiOutlineWallet, AiOutlineLogout, AiOutlineTool } from 'react-icons/ai'
import { TbReport } from "react-icons/tb";
import { GiCash, GiCoins, GiTwoCoins, GiTakeMyMoney, GiWashingMachine, GiVendingMachine, GiHamburgerMenu, GiSpiralBottle } from 'react-icons/gi'
import { RiUserLocationFill } from 'react-icons/ri'
import { CiCoinInsert } from 'react-icons/ci'
import { TfiHeadphoneAlt } from "react-icons/tfi";



import { FaFileInvoiceDollar, FaBoxes, FaDumpsterFire } from 'react-icons/fa'
import { FaClipboardList, FaWarehouse, FaFireAlt } from 'react-icons/fa'
import { ImMeter } from 'react-icons/im'
import { TbReportAnalytics } from 'react-icons/tb'
import { BiImport } from 'react-icons/bi'
import { AiFillSetting, AiOutlineReconciliation } from 'react-icons/ai'
import { HiOutlineUsers } from 'react-icons/hi'
import { MdOutlineManageAccounts, MdProductionQuantityLimits } from "react-icons/md";
import { FaPaste } from "react-icons/fa";
import LoadingPage from '../components/Loading'

import { LiaFileContractSolid } from "react-icons/lia";

import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import TreeView from '@mui/lab/TreeView';
import TreeItem, { treeItemClasses } from '@mui/lab/TreeItem';
import Typography from '@mui/material/Typography';
import MailIcon from '@mui/icons-material/Mail';
import DeleteIcon from '@mui/icons-material/Delete';
import Label from '@mui/icons-material/Label';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import InfoIcon from '@mui/icons-material/Info';
import ForumIcon from '@mui/icons-material/Forum';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { IoIosAddCircle } from 'react-icons/io';
import { AiFillMinusCircle } from 'react-icons/ai';

import { FaMapLocation } from "react-icons/fa6";
import { GiMoneyStack } from "react-icons/gi";
import { GoTasklist } from "react-icons/go";
import { IoBuildOutline } from "react-icons/io5";
import { SiNamecheap } from "react-icons/si";
import { MdPersonOff } from "react-icons/md";
import { GiAbstract063 } from "react-icons/gi";
import { AiOutlineShop } from "react-icons/ai";
import { LuGripHorizontal } from "react-icons/lu";
import { MdOutlineSettingsAccessibility } from "react-icons/md";

import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { ImUserTie } from 'react-icons/im'
import { HiFire } from 'react-icons/hi'
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { FaTreeCity } from "react-icons/fa6";
import { RiListSettingsLine } from "react-icons/ri";
import * as MaterialDesign from "react-icons/md";
import * as AntDesign from "react-icons/ai";
import * as  FontAwesomeDesign from "react-icons/fa";
import * as  GameDesign from "react-icons/gi";
import * as TablerDesign from "react-icons/tb";
import * as BootstrapDesign from "react-icons/bs";
import * as GrommetDesign from "react-icons/gr";
import * as IoniconsDesign from "react-icons/io";
import * as PhosphorDesign from "react-icons/pi";
import * as RemixDesign from "react-icons/ri";
import { logout } from '../pages/Auth/hook/useLogin'
import { useNavigate } from 'react-router-dom';



import * as Grommet from "react-icons/gr";
import * as Bootstrap from "react-icons/bs";

import { str } from 'ajv'
import zIndex from '@mui/material/styles/zIndex'
const StyledTreeItemRoot = styled(TreeItem)(({ theme }) => ({

    color: theme.palette.text.secondary,
    [`& .${treeItemClasses.content}`]: {
        color: theme.palette.text.secondary,
        //borderTopRightRadius: theme.spacing(2),
        //borderBottomRightRadius: theme.spacing(2),
        borderTopRightRadius: theme.spacing(2),
        borderBottomRightRadius: theme.spacing(2),
        flexDirection: "row-reverse",
        paddingRight: theme.spacing(0),
        //paddingRight: '2px',
        fontWeight: theme.typography.fontWeightMedium,
        '&.Mui-expanded': {
            fontWeight: theme.typography.fontWeightRegular,
        },
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
        },
        '&.Mui-focused, &.Mui-selected, &.Mui-selected.Mui-focused': {
            backgroundColor: `var(--tree-view-bg-color, ${theme.palette.action.selected})`,
            color: 'var(--tree-view-color)',
        },
        [`& .${treeItemClasses.label}`]: {
            fontWeight: 'inherit',
            color: 'inherit',
        },
    },
    // ระยะย่อหน้าของเมนูย่อย
    //
    // MUI ย่อหน้าลูกให้เองผ่าน marginLeft ของ .group แต่เดิมถูกตั้งทับเป็น 0 และตัวชดเชย
    // (paddingLeft ของ content) ถูก comment ทิ้งไว้ ผลคือเมนูย่อยอยู่ตำแหน่งแนวนอน
    // เดียวกับเมนูหลักเป๊ะ แยกด้วยตาไม่ออก และเพราะ content เป็น row-reverse ไอคอน +/-
    // จึงไปอยู่ขวาสุด กลายเป็น cue เดียวที่เหลือและมองแทบไม่เห็น
    //
    // ย่อหน้า + เส้นไกด์แนวตั้งใส่เฉพาะตอน sidebar กางอยู่ (คลาส sidebar-open)
    // ตอนหุบจะเหลือแต่ไอคอนในรางแคบ ถ้าย่อหน้าด้วยไอคอนจะเบียดออกนอกราง
    [`& .${treeItemClasses.group}`]: {
        marginLeft: 0,
    },
    [`.sidebar-open & .${treeItemClasses.group}`]: {
        marginLeft: theme.spacing(2.5),
        paddingLeft: theme.spacing(1.25),
        borderLeft: '1px solid rgba(255, 255, 255, 0.30)',
    },
}));


function StyledTreeItem(props) {
    const {
        bgColor,
        color,
        labelIcon: LabelIcon,
        labelInfo,
        labelText,
        ttitle,
        // 0 = เมนูหลัก, 1 = เมนูย่อย  ต้องดึงออกจาก props ก่อน spread
        // ไม่งั้นจะหลุดไปเป็น attribute บน DOM แล้ว React เตือน unknown prop
        depth = 0,
        ...other
    } = props;

    // เมนูย่อยลดขนาดไอคอนกับตัวอักษรและหรี่ลงเล็กน้อย
    // ระยะย่อหน้าอย่างเดียวยังอ่านเป็นชั้นเดียวกันได้ถ้าน้ำหนักตัวอักษรเท่ากัน
    const isSub = depth > 0;



    return (


        < StyledTreeItemRoot
            label={
                <Tooltip title={ttitle} placement='right-end' arrow style={{ zIndex: 1 }
                }>
                    < Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        pt: isSub ? 0.5 : 1,
                        pb: isSub ? 0.5 : 1,
                        pr: 0,
                        color: "#000",
                    }}>
                        {/*<Box component={LabelIcon} className='text-2xl' color="inherit" />*/}

                        <Box
                            component={LabelIcon}
                            className={`${isSub ? 'text-lg' : 'text-2xl'} text-white`}
                            sx={isSub ? { opacity: 0.8 } : null}
                        />


                        <Typography
                            variant="body2"
                            sx={{
                                fontWeight: isSub ? 400 : 500,
                                flexGrow: 1,
                                ...(isSub && { fontSize: '0.8rem', opacity: 0.88, pl: 0.5 }),
                            }}
                            className='text-white'
                        >
                            {labelText}
                        </Typography>
                        <Typography variant="caption" color="inherit">
                            {labelInfo}
                        </Typography>
                    </Box >
                </Tooltip >

            }
            style={{
                '--tree-view-color': color,
                '--tree-view-bg-color': bgColor,
            }}
            {...other}
        />


    );
}


StyledTreeItem.propTypes = {
    bgColor: PropTypes.string,
    color: PropTypes.string,
    labelIcon: PropTypes.elementType.isRequired,
    labelInfo: PropTypes.string,
    labelText: PropTypes.string.isRequired,
    /** 0 = เมนูหลัก, 1 = เมนูย่อย */
    depth: PropTypes.number,
};



const Sidebar = () => {
    const [open, setOpen] = useState(false)
    const location = useLocation()
    const userRole = localStorage.getItem('role');
    const userloginName = localStorage.getItem('userName');
    const [loadingPageFlag, setLoadingPageFlag] = useState(2);



    let Menus = pageMenuHandler.get() !== undefined ? (JSON.parse(pageMenuHandler.get()) ?? []) : [];


    const containerRef = useRef(null);
    const navigate = useNavigate();

    //const handleMouseDown = (e) => {
    //    const container = containerRef.current;
    //    container.isDragging = true;
    //    container.startY = e.pageY - container.offsetTop;
    //    container.scrollTopStart = container.scrollTop;
    //};

    //const handleMouseMove = (e) => {
    //    const container = containerRef.current;
    //    if (!container.isDragging) return;
    //    e.preventDefault();
    //    const y = e.pageY - container.offsetTop;
    //    const walk = (y - container.startY) * 1; // ตัวคูณความไวในการลาก
    //    container.scrollTop = container.scrollTopStart - walk;
    //};

    //const handleMouseUp = () => {
    //    const container = containerRef.current;
    //    container.isDragging = false;
    //};

    const logoutHandlerx = () => {

        if (authTokenHandler.get() != null) {
            setLoadingPageFlag(1);
            logout().then((result) => {

                const { code, status, data, message, description } = result;

                if (status === 200 || code === 200) {
                    sessionHandler.clear();
                    navigate('/login');
                } else {
                    sessionHandler.clear();
                    navigate('/login');
                }


            }).catch(error => {

                setOpenDialog(true);
                setLoadingPageFlag(2);
                console.error(error.message);
            });;
        }

    }


    const logoutHandler = async () => {
        if (authTokenHandler.get() != null) {
            setLoadingPageFlag(1);

            try {
                const result = await logout();
                const { code, status } = result;

                // ไม่ว่าจะ success หรือ fail ก็เคลียร์ session และไปหน้า login
                sessionHandler.clear();
                navigate('/login');

            } catch (error) {
                setOpenDialog(true);
                console.error(error?.message);
                navigate('/login');
            } finally {
                setLoadingPageFlag(2);

            }
        } else {
            navigate('/login');
            setLoadingPageFlag(2);
        }
    }
    //useEffect(() => {

    //    setLoadingPageFlag(0);



    //},);

    //useEffect(() => {
    //    // โค้ดนี้จะทำงานครั้งเดียวตอน component mount (เหมือน document.ready)
    //    console.log('Component is ready (เหมือน document.ready) :', loadingPageFlag);

    //    // ถ้าต้อง clean up เมื่อ unmount:
    //    return () => {
    //        setLoadingPageFlag(0);
    //    };
    //}, []);


    const menuIcon = (itemIcon) => {
        var icon = FaUserCog;
        let strIcon = itemIcon ?? "";
        try {
            if (strIcon.includes('FaUserCog')) {
                icon = FaUserCog;

            } else if (strIcon.includes('AiFillSetting')) {
                icon = AiFillSetting;
            }
            else if (strIcon.includes('BsShopWindow')) {
                icon = BsShopWindow;
            }
            else if (strIcon.includes('ImUserTie')) {
                icon = ImUserTie;
            }
            else if (strIcon.includes('HiFire')) {
                icon = HiFire;
            }
            else if (strIcon.includes('GiWashingMachine')) {
                icon = GiWashingMachine;
            }
            else if (strIcon.includes('HiOutlineUsers')) {
                icon = HiOutlineUsers;
            }
            else if (strIcon.includes('AiTwotoneShop')) {
                icon = AiTwotoneShop;
            }
            else if (strIcon.includes('MdLocalLaundryService')) {
                icon = MdLocalLaundryService;
            }
            else if (strIcon.includes('FaDumpsterFire')) {
                icon = FaDumpsterFire;
            }
            else if (strIcon.includes('BiImport')) {
                icon = BiImport;
            }
            else if (strIcon.includes('AiOutlineReconciliation')) {
                icon = AiOutlineReconciliation;
            }
            else if (strIcon.includes('GiTakeMyMoney')) {
                icon = GiTakeMyMoney;
            }
            else if (strIcon.includes('GiCash')) {
                icon = GiCash;
            }
            else if (strIcon.includes('FaFileInvoiceDollar')) {
                icon = FaFileInvoiceDollar;
            }
            else if (strIcon.includes('GiVendingMachine')) {
                icon = GiVendingMachine;
            }
            else if (strIcon.includes('MdOutlinePayments')) {
                icon = MdOutlinePayments;
            }
            else if (strIcon.includes('FaWarehouse')) {
                icon = FaWarehouse;
            }
            else if (strIcon.includes('FaClipboardList')) {
                icon = FaClipboardList;
            }
            else if (strIcon.includes('FaBoxes')) {
                icon = FaBoxes;
            }
            else if (strIcon.includes('GiTwoCoins')) {
                icon = GiTwoCoins;
            }
            else if (strIcon.includes('RiUserLocationFill')) {
                icon = RiUserLocationFill;
            }
            else if (strIcon.includes('GiSpiralBottle')) {
                icon = GiSpiralBottle;
            }
            else if (strIcon.includes('ImMeter')) {
                icon = ImMeter;
            }
            else if (strIcon.includes('MdCleaningServices')) {
                icon = MdCleaningServices;
            }
            else if (strIcon.includes('MdOutlinePayments')) {
                icon = MdOutlinePayments;
            }
            else if (strIcon.includes('AiOutlineWallet')) {
                icon = AiOutlineWallet;
            }
            else if (strIcon.includes('FaMapMarkerAlt')) {
                icon = FaMapMarkerAlt;
            }
            else if (strIcon.includes('MdOutlineManageAccounts')) {
                icon = MdOutlineManageAccounts;
            }
            else if (strIcon.includes('BsShopWindow')) {
                icon = BsShopWindow;
            }
            else if (strIcon.includes('TbListDetails')) {
                icon = TbListDetails;
            }
            else if (strIcon.includes('RiListSettingsLine')) {
                icon = RiListSettingsLine;
            }
            else if (strIcon.includes('AiOutlineTool')) {
                icon = AiOutlineTool;
            }
            else if (strIcon.includes('MdOutlineFilterList')) {
                icon = MdOutlineFilterList;
            }
            else if (strIcon.includes('FaMapMarkerAlt')) {
                icon = FaMapMarkerAlt;
            }
            else if (strIcon.includes('FaMapLocation')) {
                icon = FaMapLocation;
            }
            else if (strIcon.includes('GiMoneyStack')) {
                icon = GiMoneyStack;
            }
            else if (strIcon.includes('MdIron')) {
                icon = MdIron;
            }
            else if (strIcon.includes('FaRegCalendarAlt')) {
                icon = FaRegCalendarAlt;
            }
            else if (strIcon.includes('GoTasklist')) {
                icon = GoTasklist;
            }
            else if (strIcon.includes('IoBuildOutline')) {
                icon = IoBuildOutline;
            }
            else if (strIcon.includes('SiNamecheap')) {
                icon = SiNamecheap;
            }
            else if (strIcon.includes('MdPersonOff')) {
                icon = MdPersonOff;
            }
            else if (strIcon.includes('GiAbstract063')) {
                icon = GiAbstract063;
            }
            else if (strIcon.includes('AiOutlineShop')) {
                icon = AiOutlineShop;
            }
            else if (strIcon.includes('LuGripHorizontal')) {
                icon = LuGripHorizontal;
            }
            else if (strIcon.includes('TfiHeadphoneAlt')) {
                icon = TfiHeadphoneAlt;
            }
            else if (strIcon.includes('MdOutlineSettingsAccessibility')) {
                icon = MdOutlineSettingsAccessibility;
            }

            else if (strIcon.includes('MaterialDesign')) {
                let txtIcon = strIcon.replace('MaterialDesign.', "");
                icon = MaterialDesign[txtIcon];
            }
            else if (strIcon.includes('AntDesign')) {
                let txtIcon = strIcon.replace('AntDesign.', "");
                icon = AntDesign[txtIcon];
            }
            else if (strIcon.includes('FontAwesomeDesign')) {
                let txtIcon = strIcon.replace('FontAwesomeDesign.', "");
                icon = FontAwesomeDesign[txtIcon];
            }
            else if (strIcon.includes('GameDesign')) {
                let txtIcon = strIcon.replace('GameDesign.', "");
                icon = GameDesign[txtIcon];
            }
            else if (strIcon.includes('Grommet')) {
                let txtIcon = strIcon.replace('Grommet.', "");
                icon = Grommet[txtIcon];
            }
            else if (strIcon.includes('Bootstrap')) {
                let txtIcon = strIcon.replace('Bootstrap.', "");
                icon = Bootstrap[txtIcon];
            }

            else if (strIcon.includes('TablerDesign')) {
                let txtIcon = strIcon.replace('TablerDesign.', "");
                icon = TablerDesign[txtIcon];
            }
            else if (strIcon.includes('BootstrapDesign')) {
                let txtIcon = strIcon.replace('BootstrapDesign.', "");
                icon = BootstrapDesign[txtIcon];
            }
            else if (strIcon.includes('GrommetDesign')) {
                let txtIcon = strIcon.replace('GrommetDesign.', "");
                icon = GrommetDesign[txtIcon];
            }
            else if (strIcon.includes('IoniconsDesign')) {
                let txtIcon = strIcon.replace('IoniconsDesign.', "");
                icon = IoniconsDesign[txtIcon];
            }
            else if (strIcon.includes('PhosphorDesign')) {
                let txtIcon = strIcon.replace('PhosphorDesign.', "");
                icon = PhosphorDesign[txtIcon];
            }
            else if (strIcon.includes('RemixDesign')) {
                let txtIcon = strIcon.replace('RemixDesign.', "");
                icon = RemixDesign[txtIcon];
            }
            else {
                icon = FaUserCog
            }

        } catch (e) {

            icon = FaUserCog
        }
        return icon;

    }

    return (
        <>
            {loadingPageFlag === 1 && <LoadingPage flag={loadingPageFlag} />}

            {/*<div
                className={`${open ? 'w-60 ' : 'w-fit1 '
                    } hidden sm:block   duration-300 slide-bg-expand border-r border-gray-200 dark:border-gray-600 pt-5 pb-5    dark:bg-slate-800`}
            >*/}
            <div
                className={`${open ? 'w-60 ' : 'w-fit1 '
                    } hidden sm:block  h-screen-bar  duration-300 slide-bg-expand border-r border-gray-200 dark:border-gray-600 pt-5 pb-5    dark:bg-slate-800`}
            >


                {/*<Link to='/'>*/}
                <div className={` ${open && 'gap-x-4'} items-center`}>

                    {open ? (
                        //<span className='text-xl font-medium whitespace-nowrap dark:text-white'>
                        //    Laundry You
                        //</span>
                        <>
                            <GiHamburgerMenu
                                className={`${!open && 'rotate-180'
                                    }  text-3xl  hamberger-destop hamberger-slid fill-white   cursor-pointer     rounded-sm  p-4px  `}
                                onClick={() => setOpen(!open)}
                            />
                            <div className={open ? 'flex justify-center' : 'flex justify-start'}>
                                <img src={Logo} alt='' className='pl-2' style={{ width: "65px" }} />
                            </div>
                            <div className='clear text-center text-white'>

                                <div className='pt-4 pb-4'> {localStorage.getItem("displayName")} </div>
                                <div className='pt-4'> {localStorage.getItem("position")} </div>

                            </div>

                        </>
                    ) : (<>
                        <div className='pl-8px'>
                            <GiHamburgerMenu
                                className={`${!open && 'rotate-180'
                                    }  text-2xl  hamberger-slid fill-white   cursor-pointer       `}
                                onClick={() => setOpen(!open)}
                            /></div></>)}
                </div>
                {/*</Link>*/}
                <div
                    ref={containerRef}
                    //onMouseDown={handleMouseDown}
                    //onMouseMove={handleMouseMove}
                    //onMouseLeave={handleMouseUp}
                    //onMouseUp={handleMouseUp}
                    style={{
                        //width: "200px",
                        height: "calc(100vh - 200px)",
                        overflowY: "scroll",
                        scrollbarWidth: "none", // สำหรับ Firefox
                        msOverflowStyle: "none", // สำหรับ IE
                        //border: "1px solid #ccc",
                        position: "relative",
                    }}
                    className="hide-scrollbar" // สำหรับ Chrome ใช้ CSS ช่วยซ่อน scrollbar
                >
                    <TreeView
                        // sidebar-open เป็นตัวเปิดการย่อหน้า/เส้นไกด์ของเมนูย่อยใน
                        // StyledTreeItemRoot  ตอนหุบไม่ใส่ เพราะรางแคบและเหลือแต่ไอคอน
                        className={`slide-bg-expand${open ? ' sidebar-open' : ''}`}
                        aria-label="Menu"
                        defaultCollapseIcon={open ? <  AiFillMinusCircle color='rgb(255 255 255 / 64%)' /> : ""}
                        defaultExpandIcon={open ? <IoIosAddCircle color='rgb(255 255 255 / 64%)' /> : ""}
                        sx={open ? { flexGrow: 1, maxWidth: 400, overflowY: 'hidden', color: "#000", paddingBottom: "100px" } : { flexGrow: 1, overflowY: 'hidden', color: "#000", paddingBottom: "100px" }}

                    >



                        {

                            // Menus.filter(i => ((i.permission.includes(userRole) || (i.permission.includes("ALL")) && userRole !== "VENDER")) ||
                            //     ((i.permission.includes(userRole)) && userRole === "VENDER")

                            //).map((menu, index) => (
                            Menus?.map((menu, index) => (

                                <Link to={menu.path ?? "#"} key={index}  >
                                    <StyledTreeItem nodeId={String(menu.orderID)}
                                        action={menu.path}
                                        labelText={open ? menu.title : ""}
                                        to={menu.path}
                                        ttitle={menu.title}
                                        className="text-white"
                                        // labelInfo={ArrowDropDownIcon}
                                        labelIcon={menuIcon(menu.src)}
                                    //labelIcon={menu.src}
                                    >

                                        {

                                            // menu.sub.filter(i => i.permission.includes(userRole) || i.permission.includes("ALL"))
                                            menu.sub?.map((sub, subIndex) => (
                                                <Link to={sub.path} key={index + subIndex}>
                                                    <StyledTreeItem
                                                        nodeId={String(sub.orderID)}
                                                        depth={1}
                                                        labelText={open ? sub.title : ""}
                                                        labelIcon={menuIcon(sub.src)}
                                                        //labelIcon={sub.src}
                                                        to={sub.path}
                                                        ttitle={sub.title}

                                                    />
                                                </Link>

                                            ))}

                                    </StyledTreeItem>
                                </Link>
                            ))
                        }

                    </TreeView>
                </div>
                <div className='clear-both'></div>
                <div className={`${open ? ' flex w-60' : 'w-fit1'} panel-logout-bt`}>
                    <div className={open ? 'flex w-12/12' : 'hidden flex'}>
                        <div className='w-7/12 justify-start  flex  '>

                            <div className='pl-2 ' >
                                <img src={logoMap} />
                            </div>
                            <div className='text-white pl-2 text-left'>
                                <div className='text-xs'>  {localStorage.getItem("locationName")}</div>
                                <div className='text-xs font-bold' >  {localStorage.getItem("location")}</div>


                            </div>
                        </div>

                        <div className='w-5/12  justify-end pr-2 text-xs'>
                            {/*<a href='/login' >*/}
                            <div className='btn-logout-pink  ml-4 cursor-pointer'
                                onClick={() => {

                                    logoutHandler();
                                }}
                            >
                                Log Out
                            </div>
                            {/*</a>*/}
                        </div>
                    </div>
                    <div className={open ? 'hidden' : ' flex justify-center '}>
                        {/*<a href='/login' >*/}
                        <IconButton color="primary" aria-label="add to shopping cart" onClick={() => {

                            logoutHandler();
                        }} >
                            <AiOutlineLogout className='text-white text-2xl font-bold' />
                        </IconButton>
                        {/*<AiOutlineLogout className='text-white text-2xl font-bold' onClick={() => {

                            logoutHandler();
                        }} />*/}
                        {/*</a>*/}
                    </div>

                </div>
            </div >

        </>
    )
}

export default Sidebar
